import angular from 'angular';

angular
  .module('cxSettings')
  .controller('ChangeTwikeyAccountNumberDialogCtrl', [
    '$element',
    '$scope',
    'flySvc',
    'appUrls',
    '$http',
    'close',
    '$window',
    'openIbanSvc',
    changeTwikeyAccountNumberDialogCtrl,
  ]);

function changeTwikeyAccountNumberDialogCtrl(
  $element,
  $scope,
  flySvc,
  appUrls,
  $http,
  close,
  $window,
  openIbanSvc,
) {
  var vm = this;
  vm.accountDetails = {
    iban: null,
    bic: null,
  };

  vm.getBic = function() {
    if (!vm.accountDetails || !vm.accountDetails.iban) return;

    openIbanSvc.getBic(vm.accountDetails.iban).then(
      function(bic) {
        if (bic) vm.accountDetails.bic = bic;
      },
      function(error) {
        if (error && error.code) flySvc.error(error.code, error.parameters);
      },
    );
  };

  vm.submit = function() {
    $http.post(appUrls.api + '/api/license/UpdateTwikeyAccountNumber', vm.accountDetails).then(
      function(response) {
        if (response && response.data) {
          flySvc.success('msgChangeTwikeyAccountNumberSuccess');
          $element.modal('hide');
          close(response.data.accountNumber, 500);
        } else {
          flySvc.error('msgChangeTwikeyAccountNumberError');
        }
      },
      function(error) {
        if (error.data && error.data.code) flySvc.error(error.data.code, error.data.code);
        else flySvc.error('msgChangeTwikeyAccountNumberError');
      },
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
